var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29.5,
    fill: "#C1C1C1",
    stroke: "#C1C1C1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.08 30.168V19.176H24.608V30.168H27.08ZM20.6 20.112H10.664V22.128H17.888C17.576 25.2 14.96 27.48 9.56 28.608L10.424 30.6C17.024 29.16 20.6 25.8 20.6 20.112ZM27.728 38.688H15.392V36.672H27.08V31.128H12.872V33.048H24.608V34.872H12.92V40.656H27.728V38.688ZM50.9101 29.64H42.3421V27.48H48.6541V25.488H36.1981V22.104H48.5101V20.136H33.7501V27.48H39.8701V29.64H31.3261V31.656H50.9101V29.64ZM41.0461 32.976C36.4141 32.976 33.5821 34.416 33.5821 36.912C33.5821 39.432 36.4141 40.872 41.0461 40.872C45.8221 40.872 48.5101 39.432 48.5101 36.912C48.5101 34.416 45.7021 32.976 41.0461 32.976ZM41.0461 38.952C37.8541 38.952 36.1021 38.256 36.1021 36.912C36.1021 35.568 37.8541 34.872 41.0461 34.872C44.2381 34.872 46.0141 35.568 46.0141 36.912C46.0141 38.256 44.2381 38.952 41.0461 38.952Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileSmall);
export default __webpack_public_path__ + "static/media/profile_small.05a7a41a9142bf2ff8de515b1813365d.svg";
export { ForwardRef as ReactComponent };